import React from 'react';

import {
    OrderCardFormSummaryContainer,
    OrderCardFormNewPinDecisionContainer,
    OrderCardFormSelectAccountContainer,
    OrderCardFormNewPinEntryContainer,
} from '@/components/order-card-form';

import { orderCardSteps } from './steps';
import { useStepsControll } from './useStepsControll';

const OrderCardPage = () => {
    const { step, toNextStep } = useStepsControll();

    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                {step === orderCardSteps.chooseAccount && (
                    <OrderCardFormSelectAccountContainer toNextStep={toNextStep} />
                )}
                {step === orderCardSteps.keepPinDecision && (
                    <OrderCardFormNewPinDecisionContainer toNextStep={toNextStep} />
                )}
                {step === orderCardSteps.choosePin && <OrderCardFormNewPinEntryContainer toNextStep={toNextStep} />}
                {step === orderCardSteps.summary && <OrderCardFormSummaryContainer />}
            </div>
        </div>
    );
};

export default OrderCardPage;
